<template>
  <div class="wg-row">
    <div class="wg-row" style="justify-content:space-between;">
      <input 
          type="button" 
          :value="$anm22.strLang(lang, 'Orders list', 'Lista ordini')"
          @click="$router.push('/orders')"
      >
      <input 
          type="button" 
          :value="$anm22.strLang(lang, 'Export CSV', 'Esporta CSV')"
          @click="exportToCsv"
      >
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row com-anm22-food-chart-ext">
      <div id="chart-orders-per-day" class="com-anm22-food-chart-int" style="overflow-x:auto;"></div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row com-anm22-food-chart-ext">
      <div id="chart-covers-per-day" class="com-anm22-food-chart-int" style="overflow-x:auto;"></div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row com-anm22-food-chart-ext">
      <div id="chart-channel" class="com-anm22-food-chart-int" style="overflow-x:auto;"></div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row com-anm22-food-chart-ext">
      <div id="chart-payment" class="com-anm22-food-chart-int" style="overflow-x:auto;"></div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <div class="wg-row com-anm22-food-chart-ext">
      <div id="chart-delivery" class="com-anm22-food-chart-int" style="overflow-x:auto;"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    timezone: {
      type: String, 
      default: "Europe/Rome"
    },
    data: {
      type: Object,
      default: () => ({})
    },
    from: String,
    to: String
  },
  data() {
    return {
      chartData: null
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight,
      isOffline: state => state.offline.isOffline
    }),
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.licenseSelected);
    },
    work() {
      return this.$store.getters["works/get"](this.license.work);
    },
    start() {
      return this.$moment.tz(this.from, this.timezone);
    },
    end() {
      return this.$moment.tz(this.to, this.timezone);
    },
  },
  methods: {
    drawCharts() {
      this.drawRecapChart();
      this.drawCoverChart();
      this.drawChannelChart();
      this.drawPaymentChart();
      this.drawDeliveryChart();
    },
    drawRecapChart() {
      const data = new window.google.visualization.DataTable();
      data.addColumn('string', '');
      const revenueColumnIndex = data.addColumn('number', this.$anm22.strLang(this.lang, "Revenue", "Ricavi"));
      const ordersColumnIndex = data.addColumn('number', this.$anm22.strLang(this.lang, "Orders", "N. ordini"));
      
      const current = this.start.clone();
      while(current.isSameOrBefore(this.end, 'day')) {
        const dataElem = this.chartData[current.unix()];
        if(dataElem) {
          const date = current.format("DD-MM");
          data.addRow([date, Number(dataElem.total), Number(dataElem.orders)]);
        }
        current.add(1, 'days');
      }

      const formatter = new window.google.visualization.NumberFormat({
        pattern: 'currency'
      });

      formatter.format(data, revenueColumnIndex);

      const options = {
        chart: {
          title: this.$anm22.strLang(this.lang, 'Orders detail per day:', 'Dettaglio ordini per giorno:')
        },
        titleTextStyle: {
          fontSize: 18
        },
        backgroundColor: {
          fill: '#fff'
        },
        series: {
          0: { axis: 'revenue', color: '#40C4FF'},
          1: { axis: 'quantity', color: '#E0E0E0' }
        },
        axes: {
          y: {
            revenue: {label: this.$anm22.strLang(this.lang, "Revenue", "Ricavi")},
            quantity: {side: 'right', label: this.$anm22.strLang(this.lang, "Orders", "N. ordini")}
          }
        },
        legend: {
          position: 'none'
        },
        animation: {
          startup: true,
          duration: 1000,
          easing: 'out'
        }
      };

      const chart = new window.google.charts.Bar(document.getElementById('chart-orders-per-day'));
      chart.draw(data, window.google.charts.Bar.convertOptions(options));
    },
    drawCoverChart() {
      const data = new window.google.visualization.DataTable();
      data.addColumn('string', '');
      data.addColumn('number', this.$anm22.strLang(this.lang, "Lunch covers", "Coperti pranzo"));
      data.addColumn('number', this.$anm22.strLang(this.lang, "Dinner covers", "Coperti cena"));
      
      const current = this.start.clone();
      while(current.isSameOrBefore(this.end, 'day')) {
        const dataElem = this.chartData[current.unix()];
        const date = current.format("DD-MM");
        data.addRow([date, Number(dataElem.coverChart.lunch), Number(dataElem.coverChart.dinner)]);
        current.add(1, 'days');
      }

      const options = {
        chart: {
          title: this.$anm22.strLang(this.lang, 'Covers detail per day:', 'Dettaglio coperti per giorno:')
        },
        titleTextStyle: {
          fontSize: 18
        },
        backgroundColor: {
          fill: '#fff'
        },
        series: {
          0: {color: '#40C4FF'},
        },
        // axes: {
        //   y: {
        //     revenue: {label: this.$anm22.strLang(this.lang, "Revenue", "Ricavi")},
        //     quantity: {side: 'right', label: this.$anm22.strLang(this.lang, "Orders", "N. ordini")}
        //   }
        // },
        legend: {
          position: 'none'
        },
        animation: {
          startup: true,
          duration: 1000,
          easing: 'out'
        }
      };

      const chart = new window.google.charts.Bar(document.getElementById('chart-covers-per-day'));
      chart.draw(data, window.google.charts.Bar.convertOptions(options));
    },
    drawChannelChart() {
      const data = new window.google.visualization.DataTable();
      data.addColumn('string', '');
      data.addColumn('number', this.$anm22.strLang(this.lang, "App", "App"));
      data.addColumn('number', this.$anm22.strLang(this.lang, "Restaurant", "Ristorante"));

      const current = this.start.clone();
      while(current.isSameOrBefore(this.end, 'day')) {
        const dataElem = this.chartData[current.unix()];
        const date = current.format("DD-MM");
        data.addRow([date, Number(dataElem.channelChart.customer), Number(dataElem.channelChart.shop)]);
        current.add(1, 'days');
      }

      const options = {
        chart: {
          title: this.$anm22.strLang(this.lang, 'Submission channel:', 'Canale di provenienza:')
        },
        titleTextStyle: {
          fontSize: 18
        },
        backgroundColor: {
          fill: '#fff'
        },
        series: {
          0: { color: '#40C4FF'},
        },
        // axes: {
        //   y: {
        //     total: {label: 'Ricavi'},
        //     number: {side: 'right', label: 'Numero ordini'}
        //   }
        // },
        legend: {
          position: 'none'
        },
        animation: {
          startup: true,
          duration: 1000,
          easing: 'out'
        },
      };

      const chart = new window.google.charts.Bar(document.getElementById('chart-channel'));
      chart.draw(data, window.google.charts.Bar.convertOptions(options));
    },
    drawPaymentChart() {
      const data = new window.google.visualization.DataTable();
      data.addColumn('string', '');
      this.license.paymentMethods.forEach(pm => {
        data.addColumn('number', this.$anm22.tableClasses.worldPaymentModeType().getById(pm.id)[this.lang]);
      });

      const current = this.start.clone();
      while(current.isSameOrBefore(this.end, 'day')) {
        const dataElem = this.chartData[current.unix()];
        const date = current.format("DD-MM");
        const row = [date];
        this.license.paymentMethods.forEach(pm => {
          row.push(Number(dataElem.paymentChart[pm.id]));
        });
        data.addRow(row);
        current.add(1, 'days');
      }

      const formatter = new window.google.visualization.NumberFormat({ pattern: 'currency' });
      this.license.paymentMethods.forEach((pm, i) => {
        formatter.format(data, i);
      });

      const series = {};
      const colors = ['#40C4FF', '#ff5252', '#b2ff59'];
      this.license.paymentMethods.forEach((pm,i) => {
        series[i] = colors[i];
      });
      const options = {
        chart: {
          title: this.$anm22.strLang(this.lang, 'Payment method:', 'Metodo di pagamento:')
        },
        titleTextStyle: {
          fontSize: 18
        },
        backgroundColor: {
          fill: '#fff'
        },
        series,
        // axes: {
        //   y: {
        //     total: {label: 'Ricavi'},
        //     number: {side: 'right', label: 'Numero ordini'}
        //   }
        // },
        legend: {
          position: 'none'
        },
        isStacked: true,
        animation: {
          startup: true,
          duration: 1000,
          easing: 'out'
        },
      };

      const chart = new window.google.charts.Bar(document.getElementById('chart-payment'));
      chart.draw(data, window.google.charts.Bar.convertOptions(options));
    },
    drawDeliveryChart() {
      const data = new window.google.visualization.DataTable();
      data.addColumn('string', '');
      this.license.deliveryTypes.forEach(dt => {
        data.addColumn('number', this.$anm22.tableClasses.worldDeliveryType().getById(dt.id)[this.lang]);
      });

      const current = this.start.clone();
      while(current.isSameOrBefore(this.end, 'day')) {
        const dataElem = this.chartData[current.unix()];
        const date = current.format("DD-MM");
        const row = [date];
        this.license.deliveryTypes.forEach(dt => {
          row.push(Number(dataElem.deliveryChart[dt.id]));
        });
        data.addRow(row);
        current.add(1, 'days');
      }

      const series = {};
      const colors = ['#40C4FF', '#ff5252', '#b2ff59', '#ffab40'];
      this.license.deliveryTypes.forEach((dt,i) => {
        series[i] = colors[i];
      });
      const options = {
        chart: {
          title: this.$anm22.strLang(this.lang, 'Delivery method:', 'Metodo di consegna:')
        },
        titleTextStyle: {
          fontSize: 18
        },
        backgroundColor: {
          fill: '#fff'
        },
        series,
        // axes: {
        //   y: {
        //     total: {label: 'Ricavi'},
        //     number: {side: 'right', label: 'Numero ordini'}
        //   }
        // },
        legend: {
          position: 'none'
        },
        isStacked: true,
        animation: {
          startup: true,
          duration: 1000,
          easing: 'out'
        },
      };

      const chart = new window.google.charts.Bar(document.getElementById('chart-delivery'));
      chart.draw(data, window.google.charts.Bar.convertOptions(options));
    },
    exportToCsv() {
      const rows = [];
      // Header
      const header = [
        this.$anm22.strLang(this.lang, 'Date', 'Data'),
        this.$anm22.strLang(this.lang, 'Orders n.', 'N. ordini'),
        this.$anm22.strLang(this.lang, 'Revenue', 'Ricavi') + ' [EUR]',
        this.$anm22.strLang(this.lang, 'Lunch covers', 'Coperti pranzo'),
        this.$anm22.strLang(this.lang, 'Dinner covers', 'Coperti cena'),
        this.$anm22.strLang(this.lang, 'App channel', 'Canale App'),
        this.$anm22.strLang(this.lang, 'Restaurant channel', 'Canale Ristorante'),
      ];
      this.license.paymentMethods.forEach(pm => {
        header.push(this.$anm22.tableClasses.worldPaymentModeType().getById(pm.id)[this.lang] + ' [EUR]');
      });
      this.license.deliveryTypes.forEach(dt => {
        header.push(this.$anm22.tableClasses.worldDeliveryType().getById(dt.id)[this.lang] + ' [EUR]');
      });
      rows.push(header);

      const current = this.start.clone();
      while(current.isSameOrBefore(this.end, 'day')) {
        const dataElem = this.chartData[current.unix()];
        const date = current.format("DD-MM-YY");
        const row = [
          date,
          Number(dataElem.orders),
          Number(dataElem.total).toFixed(2),
          Number(dataElem.coverChart.lunch),
          Number(dataElem.coverChart.dinner),
          Number(dataElem.channelChart.customer),
          Number(dataElem.channelChart.shop)
        ];
        this.license.paymentMethods.forEach(pm => {
          row.push(Number(dataElem.paymentChart[pm.id]).toFixed(2));
        });
        this.license.deliveryTypes.forEach(dt => {
          row.push(Number(dataElem.deliveryChart[dt.id]).toFixed(2));
        });
        rows.push(row);
        current.add(1, 'days');
      }

      let csvContent = "data:text/csv;charset=utf-8,";
      rows.forEach(row => {
        csvContent += row.join(';') + '\n';
      })

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "yf_orders_" + this.start.format('DD-MM-YY') + '_' + this.end.format('DD-MM-YY') + ".csv");
      link.click();
    }
  },
  created() {
    this.chartData = this.data.charts.orders;
  },
  mounted() {
    // Creazione grafici
    window.google.charts.load('current', { 'packages': ['corechart', 'bar'], 'language': this.lang });
    window.google.charts.setOnLoadCallback(this.drawCharts);
  },
  watch: {
    windowWidth(newVal, old) {
      this.drawCharts();
    },
    windowHeight(newVal, old) {
      this.drawCharts();
    }
  }
}
</script>

<style lang="scss" scoped>

</style>